import type { App, Plugin as VPlugin } from 'vue'

import { createUnique } from './utils'

type FactoryPlugin = VPlugin | [VPlugin, ...Array<unknown>]

export type Plugin = {
  id: string
  load: () => Promise<FactoryPlugin>
}

export const createPlugin = (plugin: Plugin) => createUnique('plugin', plugin.id, plugin)

export const usePlugin = (app: App, _plugin: FactoryPlugin) => {
  const plugin: FactoryPlugin = Array.isArray(_plugin) ? _plugin : [_plugin]
  app.use(...plugin)
}
